import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";

export type HistoryDataTabMessages = ActionButtonMessages & {
  // Labels messages
  dateTimeLabel: string;
  statusDescriptionLabel: string;

  // Title message
  historyTitle: string;

  // No History message
  noHistoryMessage: string;

  // Status messages
  statusConfirmed: string;
  statusPaid: string;
  statusHandling: string;
  statusInvoiced: string;
  statusShipped: string;
  statusDelivered: string;
  statusCancelled: string;
  statusWaiting: string;
  statusError: string;
  statusCancellationRequest: string;
};

export const HISTORY_DATA_TAB_MESSAGES: HistoryDataTabMessages = {
  // Labels messages
  dateTimeLabel: "Data/Hora",
  statusDescriptionLabel: "Descrição do Status",

  // Title message
  historyTitle: "Histórico",

  // No History message
  noHistoryMessage: "Nenhum histórico foi encontrado.",

  // Status messages
  statusConfirmed: "Aguardando Pagamento",
  statusPaid: "Pago",
  statusHandling: "Em manuseio",
  statusInvoiced: "Faturado",
  statusShipped: "Enviado",
  statusDelivered: "Entregue",
  statusCancelled: "Cancelado",
  statusWaiting: "Orçamento",
  statusError: "Erro",
  statusCancellationRequest: "Cancelamento Solicitado",

  ...ACTION_BUTTON_MESSAGES,
};
